module.exports = __webpack_public_path__ + "media/images/icons/show_more_benefit-f86c8e4a532c1f1491431a3ed3ef6b60.svg";